import { render, staticRenderFns } from "./DetailHisense.vue?vue&type=template&id=5cb5080a&scoped=true"
import script from "./DetailHisense.vue?vue&type=script&lang=js"
export * from "./DetailHisense.vue?vue&type=script&lang=js"
import style0 from "./DetailHisense.vue?vue&type=style&index=0&id=5cb5080a&prod&lang=css"
import style1 from "./DetailHisense.vue?vue&type=style&index=1&id=5cb5080a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb5080a",
  null
  
)

export default component.exports